import requests from "./httpService";


const ExpenseServices = {
  createExpense(storeId, expenseData) {
    return requests.post(`/api/expenses/${storeId}`, expenseData);
  },

  getExpenses(storeId) {
    return requests.get(`/api/expenses/${storeId}`);
  },

  updateExpense(storeId, expenseId, expenseData) {
    return requests.put(
      `/api/expenses/${storeId}/expenses/${expenseId}`,
      expenseData
    );
  },

  deleteExpense(storeId, expenseId) {
    return requests.delete(`/api/expenses/${storeId}/${expenseId}`);
  },
};

export default ExpenseServices;
